/* eslint-disable react/no-array-index-key */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'underscore';
import Promise from 'bluebird';
import classnames from 'classnames';
import { ThemeProvider } from 'react-jss';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { BackboneViewWrapper } from '@bingads-webui-react/backbone-view-wrapper';
import { bulkEditChange } from '@bingads-webui-campaign-legacy/bulk-edit/service/bulk-edit';
import getParams from '@bingads-webui-campaign-legacy/bulk-edit/service/get-params';
import { bulkApiErrorNumberToErrorMessageMapping } from '@bingads-webui-campaign/api-errors';

import {
  MessageBar,
  MessageBarType,
} from '@bingads-webui-react/fabric-control';
import {
  Row,
  Col,
  Button,
} from '@bingads-webui-react/primitive';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import {
  ImageExperience,
  PreviewCarousel,
  MMAPreviewCarousel,
  UnifiedPreviewCarousel,
  UnifiedMMAMSANPreviewCarousel,
  SavedAdList,
  constants,
  getAutoCroppedImages,
} from '@bingads-webui-campaign-react/image-experience';
import { VideoPreviewCarousel } from '@bingads-webui-campaign-react/image-experience-video-part';
import {
  SuggestionPoller,
  MediaRepository,
  SuggestionStatus,
  mapSuggestionResponseToState,
} from '@bingads-webui-campaign/media-repository';
import { isValidUrl } from '@bingads-webui/url-util';
import { ImageOData } from '@bingads-webui-campaign/image-odata';
import {
  getAdCreatorInstrumentation,
  instrumentationScenarios,
} from '@bingads-webui-campaign/ad-creator-tools-instrumentation';
import { ImageSuggestionCarousel } from '@bingads-webui-campaign-react/image-suggestion-carousel';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import {
  getImagesFromMTAssetsAsync,
  getMultiImagesFromMTAssetsAsync,
  uploadRecommendImage,
  omitDeletedParameters,
  setMTImageModel,
  getFlattenedImageAssetList,
  updateAssetsIdsAsync,
} from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

import { AdEdit } from './ad-edit/view';
import { AccountSettingRepository } from './utils/account-setting-repository';
import { getVideosAndThumbnailsFromMTAssets } from './utils/video-repository-util';
import { logSaveAdInfoForMetrics } from './utils/save-ad-logging';
import { getTextSuggestionAdoption } from './asset-suggestion/asset-suggestion-log';
import { RecommendAdList, getRecommendCacheByUrl } from './ad-recommend';
import { BoostImage } from './boost-image';
import { getUnifiedAdPreviewConfig } from './get-unified-ad-preview-config';

const initialState = {
  shortHeadline: '',
  longHeadline: '',
  description: '',
  businessName: '',
  url: '',
  protocol: 'https://',
  callToAction: '',
  imageList: [],
  savedAdsList: [],
  videoList: [],
  thumbnailRecord: {}, // { VideoMedia16X9Thumbnail: object, ... }
  isAdEditShown: true,
  imageErrorMessages: [],
  videoErrorMessages: [],
  genericErrorMessages: [],
  errorCodes: [],
  currentAd: null,
  isBlocking: false,
  draftUnsaved: false,
  isStockPhotoEnabled: false,
  oDataConfig: null,
  videoUploading: false,
  currentSelectedImageId: null,
  currentSelectedLogoId: null,
  cropImage: null,
  blockCarousel: false,
  hasWebsiteImageOptedIn: true,
  enableAutoRotate: true,
  hasManualCroppedLogo: false,
  hasManualCroppedImage: false,
  hasUsedViewAllPlacements: false,
  isRecommendAd: false,
  hotspots: [],
  mmaBulkConversionStatus: 'Active',
  isBulkEditMMA: true,
  isBulkEditMMAUnSaved: false,
  campaignSettings: [],
  ...mapSuggestionResponseToState(SuggestionStatus.EmptyURL),
};

export class CrudAudienceAdReact extends React.Component {
  constructor(props) {
    super(props);

    this.perfMarker = props.perfMarker;
    this.perfMarker.willInit();

    this.isAdRecommendationMSANEnabled = props.isAdRecommendationMSANEnabled;
    // override only in Ad creation scenario and not opt out the prefill
    // no prefill in some test cases
    this.shouldOverrideAdInEditor = !props.ad && !_.result(props.permissions.dynamic, 'OptOutMSANAdRecommendationPrefill') && !window.e2eTestEnvironment;

    this.isMultiMediaAdsPhase2Enabled = props.permissions.IsMultiMediaAdsPhase2Enabled;
    this.IsVideoAdEditorEnabled = props.permissions &&
      props.permissions.IsVideoAdEditorEnabled;

    this.i18nErrors = DependencyResolver.get('component/api-errors-campaign/index');

    this.isMSANBoostEnabled = props.isAudienceCampaign && props.permissions.IsAmplifyEnabled;
    this.isBoostPortraitImageEnabled = this.isMSANBoostEnabled && props.permissions.IsBoostPortraitImageEnabled;
    this.isBoost200x100ImageEnabled = this.isMSANBoostEnabled && props.permissions.IsBoost200x100ImageEnabled;
    this.isBoostNewAspectRatioSupportEnabled = this.isMSANBoostEnabled && props.permissions.IsBoostNewAspectRatioSupportEnabled;

    this.isNativeAd = props.isAudienceCampaign
      && (_.result(props.viewContext.currentCampaign, 'CampaignSubType') === 'AudienceStatic'
        || _.result(props.viewContext.currentCampaign, 'CampaignSubType') === 0);

    this.isAudienceImageUpscale = this.isNativeAd && _.result(props.permissions.dynamic, 'AudienceImageUpscale');

    this.isMSANLogoAndCTAForMMAEnabled = props.isAudienceCampaign && !this.isMSANBoostEnabled
      && (_.result(props.viewContext.currentCampaign, 'CampaignSubType') === 'AudienceStatic'
        || _.result(props.viewContext.currentCampaign, 'CampaignSubType') === 0)
      && props.permissions.IsMSANLogoAndCTAForMMAEnabled;

    this.isLogoEnabled =
      (this.props.isMultimediaAd && props.permissions.IsMultiMediaAdsPhase2Enabled && !props.isRecommendation)
      || (props.isAudienceCampaign && props.permissions.IsAmplifyEnabled)
      || this.isMSANLogoAndCTAForMMAEnabled;

    this.recommendAssetIdImageUrlMap = {};
    this.imageTypesWithOrder = constants.getImageTypesWithOrder(this.props.isMultimediaAd); // eslint-disable-line max-len

    this.defaultPreviewFields = {
      shortHeadline: props.i18n.getString('Audience_Campaign_Ad_Preview_Default_ShortHeadline'),
      longHeadline: props.i18n.getString('Audience_Campaign_Ad_Preview_Default_LongHeadline'),
      description: props.i18n.getString('Audience_Campaign_Ad_Preview_Default_Description'),
      businessName: props.i18n.getString('Audience_Campaign_Ad_Preview_Default_BusinessName'),
      callToAction: props.i18n.getString('Audience_Campaign_Ad_Preview_Default_CallToAction'),
      url: 'https://example.com',
    };

    const newState = {};
    // DataProcessorFactory('nnfa');
    this.adEditRef = React.createRef();
    this.imagePreviewCarouselRef = React.createRef();
    this.videoPreviewCarouselRef = React.createRef();

    this.saveAdAsync = this.saveAdAsync.bind(this);
    this.saveMMABulkConversion = this.saveMMABulkConversion.bind(this);
    this.progressCb = this.progressCb.bind(this);
    this.cancelAdAsync = this.cancelAdAsync.bind(this);

    this.isVideo = props.isVideo && this.props.permissions.IsVideoAdsForCampaignEnabled;

    this.baseURL = `/Customers(${props.cid})/Accounts(${props.aid})/`;

    const { isMultimediaAdinMSANEnabled, isMultimediaAd, isBulkEditMMA } = this.props;
    this.isMMAEnabled = isMultimediaAdinMSANEnabled || isMultimediaAd;

    this.logInfo = {
      isGridDisplay: props.isGridDisplay,
      isVideo: this.isVideo,
      isMMAInMSAN: isMultimediaAdinMSANEnabled,
      isMMASearch: isMultimediaAd && this.isMultiMediaAdsPhase2Enabled,
      isEdit: !!props.ad,
    };

    this.logWithMetadata('responsive ad editor loaded');

    this.adPreviewPerfMarker = this.props.perfMarker.createChild('adPreviewOpen');

    // collect unSupported ratios, return back to MT when saving
    this.UiUnsupportedRatios = [];

    this.isSimplifyAudienceCreation = props.scenario === 'new-audience-static-creation';

    if (props.ad) {
      newState.currentAd = props.ad;
      newState.isBlocking = false;
      newState.shortHeadline = props.ad.Headline;
      newState.longHeadline = props.ad.LongHeadline;
      newState.description = props.ad.Text;
      if ((this.props.isMultimediaAd && this.isMultiMediaAdsPhase2Enabled) ||
        isMultimediaAdinMSANEnabled) {
        if (!_.isEmpty(props.ad.Headlines)) {
          if (_.isEmpty(_.first(props.ad.Headlines).Asset)) {
            // edit ad in campaign / ad group creation
            newState.shortHeadline = _.first(props.ad.Headlines).Text;
          } else {
            // edit in grid
            newState.shortHeadline = _.first(props.ad.Headlines).Asset.Text;
          }
        }
        if (!_.isEmpty(props.ad.LongHeadlines)) {
          if (_.isEmpty(_.first(props.ad.LongHeadlines).Asset)) {
            newState.longHeadline = _.first(props.ad.LongHeadlines).Text;
          } else {
            newState.longHeadline = _.first(props.ad.LongHeadlines).Asset.Text;
          }
        }
        if (!_.isEmpty(props.ad.Descriptions)) {
          if (_.isEmpty(_.first(props.ad.Descriptions).Asset)) {
            newState.description = _.first(props.ad.Descriptions).Text;
          } else {
            newState.description = _.first(props.ad.Descriptions).Asset.Text;
          }
        }
      }
      newState.businessName = props.ad.BusinessName;
      newState.callToAction = props.ad.CallToAction;
      newState.url = _.first(props.ad.FinalUrls);
      newState.imageList = props.ad.ImageList || [];
      if (!_.isEmpty(newState.imageList) && !_.isEmpty(_.first(newState.imageList))) {
        newState.currentSelectedImageId = this.getDefaultCurrentSelectedImageId(newState.imageList);
      }
      newState.isStockPhotoEnabled = true;
      newState.hotspots = _.map(props.ad.HotSpots, item =>
        item.Asset && {
          title: item.Asset.Title,
          desc: item.Asset.Description,
          actionText: item.Asset.ActionText,
          glyph: item.Asset.Glyph,
          uri: item.Asset.Uri,
          placement: item.Asset.Placement,
        });
      newState.oDataConfig = {
        odataRootUrl: 'test.com',
        odataPath: '/Mock/',
        odataToken: 'token',
      };

      // For Image Suggestion from Final URL
      if (props.isAdCreatorEnabled || props.isFinalUrlImageRetrievalEnabled) {
        _.extend(newState, mapSuggestionResponseToState(SuggestionStatus.FetchInProgress));
        this.onFinalUrlChanged(newState.url);
      }
    }

    this.isImageFittingEnabled = _.result(props.permissions.dynamic, 'ImageFittingMVP', false)
      && !_.result(props.permissions.dynamic, 'ImageFittingExlcudeMAE', true)
      && _.result(props.permissions.dynamic, 'ImageFittingUnifiedImageROI', false)
      && !props.ad.LegacyResponsiveAd
      && isMultimediaAdinMSANEnabled; // only enable for audience ads for MVP

    this.state = _.defaults(newState, initialState);
    this.initialVideos = [];

    this.jsdata = props.jsdata;
    this.permissions = props.permissions;
    if (this.permissions.IsMMAAutomatedCTAOptInEnabled && props.viewContext.currentCampaign && props.viewContext.currentCampaign.Id && this.jsdata && this.jsdata.Campaign) {
      const params = {
        queryParameters: {
          entitySet: edmCampaign.currentAccount.Campaigns,
        },
        bypassCache: true,
      };
      this.jsdata.Campaign.find(props.viewContext.currentCampaign.Id, params).then((data) => {
        this.setState({ campaignSettings: data.CampaignSettings });
      });
    }

    if (isMultimediaAdinMSANEnabled) {
      this.adCreatorScenario = instrumentationScenarios.MSAN;
    } else if (props.isFinalUrlImageRetrievalEnabled) {
      this.adCreatorScenario = instrumentationScenarios.MSANImage;
    } else if (isMultimediaAd) {
      this.adCreatorScenario = instrumentationScenarios.MMA;
    } else if (isBulkEditMMA) {
      this.adCreatorScenario = instrumentationScenarios.MMAConversion;
    } else {
      this.adCreatorScenario = instrumentationScenarios.default;
    }

    if (props.isAdCreatorEnabled || props.isFinalUrlImageRetrievalEnabled) {
      this.suggestionPoller = new SuggestionPoller({
        cid: props.cid,
        aid: props.aid,
        cmpId: props.viewContext.currentCampaign.Id,
        oDataConfig: props.oDataConfig,
        jobCompleteCallback: this.onPollingSuggestionCompleted.bind(this),
        logger: getAdCreatorInstrumentation(this.props.instrumentation, this.adCreatorScenario, this.props.permissions).websiteSuggestionActivity, // eslint-disable-line max-len
      });
    }

    this.mediaRepository = new MediaRepository({
      cid: props.cid,
      aid: props.aid,
      cmpId: props.viewContext.currentCampaign.Id,
      oDataConfig: props.oDataConfig,
    });

    this.imageOData = new ImageOData(props.cid, props.aid, props.oDataConfig);

    // this is an observable passed in scenarios where the save ad button is not
    // part of this view (e.g. most top of grid scenarios)
    this.hasWebsiteImageOptedInObservable = props.hasWebsiteImageOptedInObservable;

    if (!this.hasWebsiteImageOptedInObservable) {
      if (props.isAdCreatorEnabled && props.isMultimediaAdinMSANEnabled) {
        this.hasWebsiteImageOptedInObservable = (newValue) => {
          this.setState({
            hasWebsiteImageOptedIn: newValue,
          });
        };
      } else {
        this.hasWebsiteImageOptedInObservable = _.noop;
      }
    }

    this.enableAdPreviewLibrary = _.get(props.permissions.dynamic, 'AdPreviewLibrarySearchMMA', false);
    this.props.activityLogger.signal(`crud-audience-ad-react constructor: ${props.permissions.dynamic && props.permissions.dynamic.MMACopilot}`, 'rae-view deprecation');
  }

  componentDidMount() {
    this.openTime = new Date();
    if (this.props.ad) {
      if (this.isVideo) {
        this.fetchAndFillVideosAsync();
      } else if (_.isEmpty(this.state.imageList)) {
        this.fetchAndFillImagesAsync();
      }
    }
    this.props.activityLogger.signal(`ad editor opened: isGrid: ${this.props.isGridDisplay}, isEdit: ${!!this.props.ad}, isVideo: ${!!this.isVideo}, url: ${this.state.url}`, 'responsive ad editor');

    this.perfMarker.done();
  }

  componentDidUpdate() {
    if (this.props.isBulkEditMMA) return;
    if (this.props.isImproveMMA) return;
    if (this.props.isAdCreatorEnabled && this.adEditRef.current && this.adEditRef.current.view.$) {
      // disable this from running in unit tests ReactDOM.render will always fail because the 2nd arg is
      // not attached to any DOM in unit test scenario
      const disabled = (this.state.imageList.length >= constants.DEFAULT_MAX_IMAGE || this.isMSANBoostEnabled);

      ReactDOM.render(
        <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }}>
          {
            !disabled &&
            <UiBlocker
              blocking={this.state.blockCarousel}
              loadingText={this.props.i18n.getString('Loading')}
            >
              <ImageSuggestionCarousel
                isLoading={!!this.state.suggestion.inProgress}
                images={this.state.carousel.images || []}
                i18n={this.props.newI18n}
                isEmpty={this.state.carousel.isError}
                messageInfo={this.state.carousel.message}
                onSelectImage={(imageSource, index, suggestionId) => {
                  const { websiteSuggestionCarouselActivity } =
                    getAdCreatorInstrumentation(this.props.instrumentation, this.adCreatorScenario);

                  websiteSuggestionCarouselActivity.trace(`CarouselImageSelected: ${index};`);

                  this.setState({ blockCarousel: true });
                  this.state.addImageCallback(imageSource, constants.imageOptionKeys.Image, suggestionId)
                    .then((error = {}) => {
                      if (error && error.errorMessage) {
                        this.setState({
                          carousel: {
                            ...this.state.carousel,
                            message: {
                              type: MessageBarType.error,
                              message: error.errorMessage,
                            },
                          },
                        });
                      }
                      return Promise.resolve();
                    })
                    .finally(() => {
                      this.setState({ blockCarousel: false });
                    });
                  this.setState({
                    carousel: {
                      ...this.state.carousel,
                      images: _.reject(this.state.carousel.images, (val, ind) => ind === index),
                    },
                  });
                }}
                onSelectSeeAll={() => this.state.openAddImageCallback()}
              />
            </UiBlocker>
          }
        </ThemeProvider>,
        this.adEditRef.current.view.$('.image-suggestion-carousel')[0]
      );
    }
  }

  componentWillUnmount() {
    if (this.suggestionPoller) {
      this.suggestionPoller.cancel();
    }
  }

  onPollingSuggestionCompleted(response, isSubdomainScraping) {
    if (response.error) {
      // error handling section
      this.setState(mapSuggestionResponseToState(SuggestionStatus.ServerError, response));
    } else {
      this.setState(mapSuggestionResponseToState(
        SuggestionStatus.FetchSucceed,
        response,
        isSubdomainScraping
      ));
    }
  }

  onAdFieldUpdated = (updatedObj) => {
    const { isFinalUrlImageRetrievalEnabled, isAdCreatorEnabled } = this.props;

    switch (updatedObj.updatedElement) {
      case 'LongHeadline':
        this.setState({ longHeadline: updatedObj.text });
        break;

      case 'ShortHeadline':
        this.setState({ shortHeadline: updatedObj.text });
        break;

      case 'Description':
        this.setState({ description: updatedObj.text });
        break;

      case 'BusinessName':
        this.setState({ businessName: updatedObj.text });
        break;

      case 'FinalUrl': {
        const newUrl = updatedObj.url;
        let newState = {};


        if (isAdCreatorEnabled || isFinalUrlImageRetrievalEnabled) {
          const control = this.adEditRef.current.view.adPropertiesToControlMap.FinalUrls;

          let validURL;
          if (this.adEditRef.current.view.isMSANBoostEnabled) {
            const uriRegex = /^(\S+:(\/\/)?)(\S+)/;
            validURL = uriRegex.test(newUrl);
          } else {
            validURL = isValidUrl(newUrl);
          }

          if (_.isEmpty(newUrl)) {
            newState = mapSuggestionResponseToState(SuggestionStatus.EmptyURL);
            control.setError(this.props.i18n.getString('Audience_Campaign_Ad_Error_RequiredField'));
          } else if (!validURL) {
            newState = mapSuggestionResponseToState(SuggestionStatus.InvalidURL);
            control.setError(this.props.i18nErrors.getString('API_ErrorNumber_2611')); // eslint-disable-line react/prop-types
          } else {
            newState = mapSuggestionResponseToState(SuggestionStatus.FetchInProgress);
            control.setError('');
          }
        }

        this.setState(
          _.extend({ url: newUrl }, newState),
          (isAdCreatorEnabled || isFinalUrlImageRetrievalEnabled) ? () => {
            this.onFinalUrlChanged(newUrl);
          } : undefined
        );
        break;
      }
      case 'CallToAction':
        this.setState({ callToAction: updatedObj.text });
        break;

      default:
        break;
    }
  };

  onUpdateFinalUrlPrefix = (ev, newPrefix) => {
    this.setState({ protocol: newPrefix.text });
    this.adEditRef.current.view.updateFinalUrlPrefix(newPrefix.text);
  };

  onUpdateHotspots = (hotspots) => {
    this.setState({
      hotspots,
    });
  };

  onUpdateFinalUrl = (ev) => {
    let newState = {};
    const newUrl = ev && ev.target && ev.target.value;
    if (this.props.isAdCreatorEnabled) {
      const finalUrlControl = this.adEditRef.current.view.adPropertiesToControlMap.FinalUrls;
      if (!isValidUrl(this.state.protocol + newUrl)) {
        newState = mapSuggestionResponseToState(SuggestionStatus.InvalidURL);
        finalUrlControl.setError(this.props.i18nErrors.getString('API_ErrorNumber_2611')); // eslint-disable-line react/prop-types
      } else {
        newState = mapSuggestionResponseToState(SuggestionStatus.FetchInProgress);
        finalUrlControl.setError('');
      }
    }

    this.setState(
      _.extend({ url: this.state.protocol + newUrl }, newState),
      this.props.isAdCreatorEnabled ? () => {
        this.onFinalUrlChanged(this.state.protocol + newUrl);
      } : undefined
    );
    this.adEditRef.current.view.updateFinalUrl(this.state.protocol + newUrl);
    this.adEditRef.current.view.finalURLChange();
    // call to fetch RSA text field recommendations after updating URL in website image view
  };


  onFinalUrlChanged = _.debounce((url) => {
    // cancel existing suggestion poller jobs
    if (this.suggestionPoller) {
      this.suggestionPoller.cancel();
    }
    if (this.state.suggestion.inProgress && isValidUrl(url)) {
      // first param is aspectRatio type, we don't need it here, so deliver null
      const minimumSize = constants.getMinimumSizeForImage(null, this.props.isMultimediaAd);
      this.suggestionPoller.getLandingPageSuggestions({
        landingPageUrl: url,
        enableOfflinePollingDelay: this.props.enableOfflinePollingDelay,
        minimumResolution: {
          width: minimumSize[0],
          height: minimumSize[1],
        },
      });
    }
  }, 1000);

  onImageListUpdated = (imageList, currentSelectedId, isLogo) => {
    const newState = {
      imageList,
      enableAutoRotate: true,
      cropImage: null,
    };

    this.props.activityLogger.signal(`image added: MMAinMSAN: ${this.props.isMultimediaAdinMSANEnabled}`, 'responsive ad editor');

    // log when new images added in audience ads editor
    if (this.props.isMultimediaAdinMSANEnabled) {
      // eslint-disable-next-line newline-per-chained-call
      const newImageList = _.chain(imageList).flatten().map(img => `${img.id}`).uniq().sortBy().value();
      // eslint-disable-next-line newline-per-chained-call
      const curImageList = _.chain(this.state.imageList).flatten().map(img => `${img.id}`).uniq().sortBy().value();
      const newImages = _.difference(newImageList, curImageList);
      if (newImages.length > 0) {
        this.props.activityLogger.signal(`new images added, isEditing:${!!this.props.ad}, image ids:${newImages.join(',')}, image count:${newImages.length}`, 'responsive ad editor');
      }
    }

    if ((this.isMMAEnabled && imageList.length > 0) ||
      imageList.length === this.imageTypesWithOrder.length) {
      newState.imageErrorMessages = [];
    }

    if (this.isMMAEnabled) {
      let selectedId = currentSelectedId || (isLogo ? this.state.currentSelectedLogoId : this.state.currentSelectedImageId);
      const exist = this.findImageSetById(
        isLogo ? this.getLogoList(imageList) : this.getImageListWithoutLogo(imageList),
        isLogo ? this.state.currentSelectedLogoId : this.state.currentSelectedImageId
      );

      if (!exist) {
        if (imageList.length > 0) {
          selectedId = isLogo ?
            this.getDefaultCurrentSelectedLogoId(imageList) :
            this.getDefaultCurrentSelectedImageId(imageList);
        } else {
          selectedId = null;
        }
      }

      if (isLogo) {
        newState.currentSelectedLogoId = selectedId;
      } else {
        newState.currentSelectedImageId = selectedId;
      }
    }

    this.setState(newState);

    if (this.props.isAdCreatorEnabled || this.props.isFinalUrlImageRetrievalEnabled) {
      const list = _.flatten(newState.imageList, 1);

      AccountSettingRepository.getAccountSettings(['AllowCrawlImagesFromLandingPage']).then((response) => {
        const shouldEnableOptIn =
          _.result(response, 'AllowCrawlImagesFromLandingPage') !== 'true' &&
          _.some(
            list,
            image =>
              image.source === constants.imageSources.Website ||
              image.source === constants.imageSources.WebsiteCarousel ||
              image.source === constants.imageSources.AdRecommendation
          );

        if (this.adEditRef.current) {
          const isOptedIn = this.adEditRef.current.view.viewModel.hasWebsiteImageOptIn();

          this.adEditRef.current.view.viewModel.showWebsiteImageOptIn(shouldEnableOptIn);
          if (shouldEnableOptIn) {
            this.hasWebsiteImageOptedInObservable(isOptedIn);
          } else {
            this.hasWebsiteImageOptedInObservable(true);
          }
        }
      });
    }
  };

  onVideoListUpdated = (videoList) => {
    const newState = { videoList, draftUnsaved: false };

    if (videoList.length === constants.videoTypesWithOrder.length) {
      newState.videoErrorMessages = [];
    }
    // eslint-disable-next-line max-len
    const isCreate = this.initialVideos.length === 0 && videoList.length === constants.videoTypesWithOrder.length;
    const isVideoUpdated = this.initialVideos.length === videoList.length &&
      videoList.some((video, index) => video.Id !== this.initialVideos[index].Id);
    newState.draftUnsaved = isCreate || isVideoUpdated;

    this.setState(newState);
  };

  onSaveThumbnailAsDraft = ({
    thumbnailRecord,
  }) => {
    this.props.activityLogger.signal('save video thumbnail as draft', 'responsive ad editor');
    this.setState({
      thumbnailRecord,
      draftUnsaved: true,
    });
  };

  onVideoUploadStatusUpdate = (videoUploading) => {
    this.setState({
      videoUploading,
      videoErrorMessages: [],
    });
  };

  onImagePreviewRequested = (type) => {
    if (this.imagePreviewCarouselRef.current) {
      this.imagePreviewCarouselRef.current.setPreviewIndexByType(type);
    }
  };

  onVideoPreviewRequested = (type) => {
    if (this.videoPreviewCarouselRef.current) {
      this.videoPreviewCarouselRef.current.setPreviewIndexByType(type);
    }
  };

  onImageSelected = (imageId, isLogoSelected = false) => {
    if (isLogoSelected) {
      this.setState({
        currentSelectedLogoId: imageId,
      });
    } else {
      this.setState({
        currentSelectedImageId: imageId,
      });
    }
  };

  onImageEditCancelled = () => {
    this.setState({
      cropImage: null,
      enableAutoRotate: true,
    });
  };

  onCropImage = (imageObj) => {
    this.setState({
      cropImage: imageObj,
      enableAutoRotate: false,
    });
  };

  onAddAspectRatio = (imageType) => {
    const { imageList, currentSelectedImageId } = this.state;

    // We don't support logo in ad preview, so we need to filter out logo images
    const imageListWithoutLogo = this.getImageListWithoutLogo(imageList);
    const previewImages = this.findImageSetById(imageListWithoutLogo, currentSelectedImageId);

    let newPreviewImages = null;
    const targetedRatioIdx = _.findIndex(previewImages, image => image.type === imageType);
    if (targetedRatioIdx >= 0) {
      const targetedRatio = previewImages[targetedRatioIdx].clone();
      targetedRatio.setIncluded(true);
      newPreviewImages = [...previewImages];
      newPreviewImages.splice(targetedRatioIdx, 1, targetedRatio);
    } else {
      // for image added before partial aspect ratio is supported, may missed some ratio info
      const croppedImages = getAutoCroppedImages({
        originalImageToCrop: _.first(previewImages),
        isMultimediaAd: this.props.isMultimediaAd,
        isMultimediaAdinMSANEnabled: this.props.isMultimediaAdinMSANEnabled,
      });
      const target = _.find(croppedImages, image => image.type === imageType);
      target.isIncluded = true;
      newPreviewImages = [...previewImages, target];
      newPreviewImages.sort((a, b) => b.aspectRatio - a.aspectRatio);
    }

    const newImageList = this.setImageSetById(imageList, currentSelectedImageId, newPreviewImages);
    this.onImageListUpdated(newImageList, currentSelectedImageId);
    return newImageList;
  };

  onRemoveAspectRatio = (imageType) => {
    const { imageList, currentSelectedImageId } = this.state;

    // We don't support logo in ad preview, so we need to filter out logo images
    const imageListWithoutLogo = this.getImageListWithoutLogo(imageList);
    const previewImages = this.findImageSetById(imageListWithoutLogo, currentSelectedImageId);

    const targetedRatioIdx = _.findIndex(previewImages, image => image.type === imageType);
    if (targetedRatioIdx >= 0) {
      const targetedRatio = previewImages[targetedRatioIdx].clone();
      targetedRatio.setIncluded(false);
      const newPreviewImages = [...previewImages];
      newPreviewImages.splice(targetedRatioIdx, 1, targetedRatio);
      const newImageList = this.setImageSetById(imageList, currentSelectedImageId, newPreviewImages);
      this.onImageListUpdated(newImageList, currentSelectedImageId);
      return newImageList;
    }
    return imageList;
  };

  onAdSaved = (savedAd, imageToGenerateThumbnail) => {
    // from MT return, construct a object that AdList needs
    let formattedSavedAd;
    if (this.props.isMultimediaAdinMSANEnabled) {
      formattedSavedAd = _.pick(
        savedAd,
        'Id',
        'BusinessName',
        'Headlines',
        'LongHeadlines',
        'Descriptions'
      );
    } else {
      formattedSavedAd = _.pick(
        savedAd,
        'Id',
        'Headline',
        'LongHeadline',
        'Text',
        'BusinessName'
      );
    }

    // get the thumbnail
    // eslint-disable-next-line no-nested-ternary
    formattedSavedAd.ThumbnailForAdList = (this.isVideo ?
      this.state.videoList[0] : imageToGenerateThumbnail)
      .ThumbnailForAdList;

    formattedSavedAd.FinalUrls = savedAd.FinalUrls;

    formattedSavedAd.Id = parseInt(formattedSavedAd.Id, 10);

    const savedAdsListWithoutDuplicate =
      _.reject(
        this.state.savedAdsList,
        savedAdItem => parseInt(savedAdItem.Id, 10) === formattedSavedAd.Id
      );

    this.setState(_.defaults({
      savedAdsList: [
        ...savedAdsListWithoutDuplicate,
        formattedSavedAd,
      ],
      isAdEditShown: false,
      draftUnsaved: false,
    }, initialState), () => {
      this.props.onAdSaved(
        savedAd,
        imageToGenerateThumbnail &&
        (imageToGenerateThumbnail.src || imageToGenerateThumbnail.originalUrl)
      );
    });
  };

  onEditAd = (adId) => {
    const {
      isMultimediaAdinMSANEnabled,
    } = this.props;

    this.setState({
      isBlocking: true,
    });

    let extraExpand = '';

    if (isMultimediaAdinMSANEnabled) {
      extraExpand = ',Model.ResponsiveAd/Headlines,Model.ResponsiveAd/LongHeadlines,Model.ResponsiveAd/Descriptions';
    }

    this.props.responsiveAdRepository.getAdAsync(adId, extraExpand).then((ad) => {
      this.setState({
        shortHeadline: ad.Headline,
        longHeadline: ad.LongHeadline,
        description: ad.Text,
        businessName: ad.BusinessName,
        url: _.first(ad.FinalUrls),
        callToAction: ad.CallToAction,
      });
      if (this.isVideo) {
        return getVideosAndThumbnailsFromMTAssets(
          this.props.odata,
          this.baseURL,
          ad.Videos
        ).then(({ videoList, thumbnailRecord }) => {
          this.setState({
            videoList,
            thumbnailRecord,
            isAdEditShown: true,
            currentAd: ad,
            draftUnsaved: false,
          });
          this.initialVideos = videoList;
        });
      }

      return this.initializeImagesModelInternal({ ad }).then(({
        images,
        currentSelectedImageId,
      }) => {
        this.setState({
          isAdEditShown: true,
          currentAd: ad,
          imageList: images,
          currentSelectedImageId,
        });
      });
    }).finally(() => {
      this.setState({
        isBlocking: false,
      });
    });
  };

  onRemoveAd = (adId) => {
    this.setState({
      isBlocking: true,
    });

    this.props.responsiveAdRepository.removeAdAsync(adId).then(() => {
      // remove the Ad from the list
      const updatedSavedAdsList =
        _.reject(this.state.savedAdsList, savedAd => parseInt(savedAd.Id, 10) === adId);

      this.setState({
        savedAdsList: updatedSavedAdsList,
        isAdEditShown: updatedSavedAdsList.length === 0,
      });
    }).finally(() => {
      this.setState({
        isBlocking: false,
      });
    });
  };

  onCreateAd = () => {
    this.props.activityLogger.signal(`crud-audience-ad-react saveToClient: ${JSON.stringify(this.pilotCheckLogInfo())}`, 'rae-view deprecation');

    // When reusing the ad edit, clear and reset the Backbone view
    if (this.adEditRef.current) {
      this.adEditRef.current.view.clear();
    }

    this.setState(_.defaults(
      { savedAdsList: this.state.savedAdsList },
      initialState
    ));
    this.initialVideos = [];
  };

  onSaveRecommendAd = async () => {
    await this.saveAdAsync({ recommendSave: true });
  };

  onSavePortraitImage = (portraitImage) => {
    this.portraitImage = portraitImage;
  };

  setUpAdWithRecommendAd = async ({
    ad,
    isAdEditShown = this.state.isAdEditShown,
    shouldSaveAdFromRecommend,
  }) => {
    const {
      odata, cid, aid, oDataConfig,
    } = this.props;
    this.setState({
      shortHeadline: ad.Headline || _.get(ad.Headlines, ['0', 'Asset', 'Text']),
      longHeadline: ad.LongHeadline || _.get(ad.LongHeadlines, ['0', 'Asset', 'Text']),
      description: ad.Text || _.get(ad.Descriptions, ['0', 'Asset', 'Text']),
      businessName: ad.BusinessName,
      url: _.first(ad.FinalUrls),
      callToAction: ad.CallToAction,
      isBlocking: true,
    });

    try {
      const uploadedImageIds = await uploadRecommendImage(ad.Images, {
        cid, aid, oDataConfig,
      }, this.recommendAssetIdImageUrlMap);
      const images = await getMultiImagesFromMTAssetsAsync(odata, this.baseURL, ad.Images, false, false, this.props.isMMAV2Enabled);

      _.each(images, (ImageExperiences) => {
        _.each(ImageExperiences, (image) => {
          if (_.contains(uploadedImageIds, image.id)) {
            // eslint-disable-next-line no-param-reassign
            image.source = constants.imageSources.AdRecommendation;
          }
        });
      });

      let currentSelectedImageId;
      if (this.isMMAEnabled && images.length > 0) {
        currentSelectedImageId = this.getDefaultCurrentSelectedImageId(images);
      }

      this.setState({
        isAdEditShown,
        currentAd: ad,
        imageList: images,
        currentSelectedImageId,
        isRecommendAd: true,
        isBlocking: false,
      }, () => {
        this.onImageListUpdated(images);
        if (shouldSaveAdFromRecommend) {
          this.onSaveRecommendAd();
        }
      });
    } catch (error) {
      throw new Error('Failed to set up ad with recommend ad');
    } finally {
      this.setState({
        isBlocking: false,
      });
    }
  };

  /**
   * Sets the input elements on the ad model, and returns an object with the parameters
   * needed for the save request.
   *
   * @returns {object} Object with parameters to save the ad.
   *
   */
  getData() {
    let data = this.adEditRef.current.view.getData();

    if (this.isVideo) {
      const videos = _.map(this.state.videoList, videoObj => videoObj.formatToSave());
      const thumbnails = this.IsVideoAdEditorEnabled ?
        // eslint-disable-next-line max-len
        _.map(_.compact(_.values(this.state.thumbnailRecord)), thumbnail => thumbnail.formatToSave(false, true, true))
        : [];

      data.Videos = JSON.stringify([...videos, ...thumbnails]);
    } else if (!this.props.isAdCreatorEnabled) {
      // when ad creator is enabled, the images data model are generated later after async calls
      // Only fill in images data model when ad creator is off to not cause confusion
      setMTImageModel(
        data,
        {},
        this.state.imageList,
        {
          isMultimediaAdinMSANEnabled: this.props.isMultimediaAdinMSANEnabled,
          isMultimediaAd: this.props.isMultimediaAd,
          isMMAV2Enabled: this.props.isMMAV2Enabled,
        },
        this.UiUnsupportedRatios
      );
    }

    if (!this.props.isMobileUrlEnabled) {
      data = _.omit(data, ['MobileFinalUrls']);
    }

    if (!this.props.isImpressionTrackingUrlsEnabled) {
      data = _.omit(data, ['ImpressionTrackingUrls']);
    }

    return data;
  }

  // on top of getData, for images with effects, we need to update image id
  getProcessedDataAsync(originalData) {
    if (this.isVideo) {
      return Promise.resolve({
        mtModel: originalData,
      });
    }

    const flattenedIncludedImageAssetList = getFlattenedImageAssetList(this.state.imageList, this.props.isMultimediaAdinMSANEnabled, this.props.isMultimediaAd);
    const imageIndexAsThumbnail = 0;

    return updateAssetsIdsAsync(flattenedIncludedImageAssetList, imageIndexAsThumbnail, this.props.isAdCreatorEnabled, this.imageOData)
      .then((updates) => {
        const originalThumbnailAsset = flattenedIncludedImageAssetList[imageIndexAsThumbnail];
        const overrideInfo = updates[imageIndexAsThumbnail];
        let imageToGenerateThumbnail;

        if (overrideInfo) {
          imageToGenerateThumbnail = originalThumbnailAsset.copyThumbnailLookToNewImage({
            id: overrideInfo.id,
            src: overrideInfo.bingSrc,
          });
        } else {
          imageToGenerateThumbnail = originalThumbnailAsset;
        }

        if (this.props.isAdCreatorEnabled) {
          // when adcreator is off, selection happens earlier in getData/getMMAPayload
          // When adcreator is on, selection happens later here after ids are updated
          setMTImageModel(
            originalData,
            updates,
            this.state.imageList,
            {
              isMultimediaAdinMSANEnabled: this.props.isMultimediaAdinMSANEnabled,
              isMultimediaAd: this.props.isMultimediaAd,
              isMMAV2Enabled: this.props.isMMAV2Enabled,
              isBoostPortraitImageEnabled: this.isBoostPortraitImageEnabled,
              isBoost200x100ImageEnabled: this.isBoost200x100ImageEnabled,
              isBoostNewAspectRatioSupportEnabled: this.isBoostNewAspectRatioSupportEnabled,
              isImageFittingEnabled: this.isImageFittingEnabled,
            },
            this.UiUnsupportedRatios,
            this.portraitImage
          );
        }

        return {
          mtModel: originalData,
          imageToGenerateThumbnail,
        };
      });
  }

  /**
   * Sets the error messages for the list of errors received as response from the
   * ad creation/update.
   *
   * @param {object} errors List of errors from response
   *
   * @returns {undefined} no return value
   *
   */
  /* istanbul ignore next */

  setResponseErrors(errors) {
    _.forEach(errors, (error) => {
      // fix the bug that error message is not shown for images
      error.Property === 'Images' &&
        this.setState({
          imageErrorMessages: [
            this.props.i18nErrors.getString(`API_ErrorNumber_${error.ErrorNumber}`) || this.props.i18nErrors.getString('ErrorNumber_-1'),
          ],
        });

      if (!this.adEditRef.current.view.setError(error)) {
        this.setState({
          genericErrorMessages: [
            ...this.state.genericErrorMessages,
            error.message,
          ],
        });
      }
    });

    this.setState({
      errorCodes: _.map(errors, error => error.ErrorNumber),
    });
  }

  setBulkEditStatus(status) {
    this.setState({
      mmaBulkConversionStatus: status,
    });
  }

  getFirstElement(item) {
    if (_.isArray(item)) {
      return _.first(item);
    }
    return item;
  }

  getLogo = (imageList) => {
    const { currentSelectedLogoId } = this.state;

    const logos = _.filter(imageList, imageArr =>
      this.getFirstElement(imageArr).isLogo === true);
    if (currentSelectedLogoId) {
      return _.find(logos, logo => _.first(logo).Id === currentSelectedLogoId) || _.first(logos);
    }
    return _.first(logos);
  };

  getImageListWithoutLogo = imageList => _.filter(imageList, imageArr =>
    this.getFirstElement(imageArr).isLogo !== true);

  getLogoList = imageList => _.filter(imageList, imageArr =>
    this.getFirstElement(imageArr).isLogo === true);

  getImagesForPreview() {
    const { imageList, currentSelectedImageId } = this.state;
    if (this.isMMAEnabled) {
      // We don't support logo in ad preview, so we need to filter out logo images
      const imageListWithoutLogo = this.getImageListWithoutLogo(imageList);

      if (currentSelectedImageId) {
        const previewImages =
          this.findImageSetById(imageListWithoutLogo, currentSelectedImageId);

        if (previewImages) {
          return previewImages;
        }
      }

      if (imageListWithoutLogo.length > 0) {
        return _.first(imageListWithoutLogo);
      }

      return [];
    }

    return imageList;
  }

  getPreviewTexts = () => ({
    longHeadline: this.state.longHeadline && this.state.longHeadline.length > 0 ?
      this.state.longHeadline : this.defaultPreviewFields.longHeadline,
    shortHeadline: this.state.shortHeadline && this.state.shortHeadline.length > 0 ?
      this.state.shortHeadline : this.defaultPreviewFields.shortHeadline,
    description: this.state.description && this.state.description.length > 0 ?
      this.state.description : this.defaultPreviewFields.description,
    businessName: this.state.businessName && this.state.businessName.length > 0 ?
      this.state.businessName : this.defaultPreviewFields.businessName,
    url: this.state.url && this.state.url.length > 0 ?
      this.state.url : this.defaultPreviewFields.url,
    callToAction: this.state.callToAction && this.state.callToAction.length > 0 ?
      this.state.callToAction : this.defaultPreviewFields.callToAction,
  });

  getDefaultCurrentSelectedImageId(imageList) {
    const firstPlacementOfFirstImage = _.first(this.getImageListWithoutLogo(imageList)[0]);

    return this.props.isAdCreatorEnabled
      ? _.result(firstPlacementOfFirstImage, 'BaseId') : _.result(firstPlacementOfFirstImage, 'Id');
  }

  getDefaultCurrentSelectedLogoId(imageList) {
    const firstLogo = _.first(this.getLogo(imageList));
    return _.result(firstLogo, 'Id');
  }

  getOptInPreferenceFlag() {
    const { isMultimediaAdinMSANEnabled } = this.props;

    return isMultimediaAdinMSANEnabled ? constants.preferenceFlags.MMAInMSANWebsiteImageOptIn
      : constants.preferenceFlags.MMAWebsiteImageOptIn;
  }

  setUnSupportedRatios(images = [], isMultimediaAdinMSANEnabled) {
    if (isMultimediaAdinMSANEnabled) {
      const msanAspectRatioAssociations =
        Object.values(constants.getAspectRatios({ isMultimediaAdinMSANEnabled }))
          .map(item => item.associationType);
      this.UiUnsupportedRatios = images.filter(image => !_.contains(msanAspectRatioAssociations, _.get(image, ['Asset', 'SubType'])));
    }
  }
  getBulkEditParams(params) {
    const {
      CallToAction, CallToActionLanguage, Images, BusinessName, AdStatus,
    } = params;
    const { allPages, selectedItems, filterService } = this.props;
    const AdditionalData = {
      BusinessName,
      Images,
      CallToAction,
      CallToActionLanguage,
      Status: AdStatus,
    };
    const batchAction = {
      Actions: [{
        PasteAs: 'MultiMediaAd',
        '@odata.type': '#Model.CopyAction',
        AdditionalData: JSON.stringify(AdditionalData),
      }],
      EditCopy: false,
    };
    const filters = _.result(filterService, 'query');
    const projection = {
      selectedIds: allPages ? [] : _.pluck(selectedItems, 'Id'),
      isSelectAll: allPages,
      filters,
    };
    const finalParams = getParams(projection, batchAction, 'Ad');
    finalParams.Selection.QueryString = finalParams.Selection.QueryString.replace(/CampaignType%20/g, 'Campaign%2FCampaignType%20').replace(/CampaignStatus%20/g, 'Campaign%2FStatus%20').replace(/AdGroupStatus%20/g, 'AdGroup%2FStatus%20');
    return finalParams;
  }

  setImageSetById = (imageList, baseImageId, newImageSet) => {
    if (!baseImageId) return false;

    let imageSetIdx;

    if (this.props.isAdCreatorEnabled) {
      imageSetIdx = _.findIndex(imageList, placements =>
        placements[0].BaseId.toString() === baseImageId.toString());
    } else {
      imageSetIdx = _.findIndex(imageList, placements =>
        _.some(placements, placement => placement.Id.toString() === baseImageId.toString()));
    }

    if (imageSetIdx >= 0) {
      const newImageList = [...imageList];
      newImageList.splice(imageSetIdx, 1, newImageSet);
      return newImageList;
    }
    return [...imageList, newImageSet];
  };

  pilotCheckLogInfo = () => ({
    isGridDisplay: this.props.isGridDisplay,
    isImproveMMA: this.props.isImproveMMA,
    isRecommendation: this.props.isRecommendation,
    isMultimediaAd: this.props.isMultimediaAd,
    isAdCreatorEnabled: this.props.isAdCreatorEnabled,
    isPlaceholderMMA: this.props.isPlaceholderMMA,
    isMMAV2Enabled: this.props.isMMAV2Enabled,
    isBulkEditMMA: this.props.isBulkEditMMA,
  });

  findImageSetById = (imageList, baseImageId) => {
    if (!baseImageId) return false;

    let imageSetToEdit;

    if (this.props.isAdCreatorEnabled) {
      imageSetToEdit = _.find(imageList, placements =>
        placements[0].BaseId.toString() === baseImageId.toString());
    } else {
      imageSetToEdit = _.find(imageList, placements =>
        _.some(placements, placement => placement.Id.toString() === baseImageId.toString()));
    }

    return imageSetToEdit;
  };

  isOnlyOneIncludedImage = (ratio) => {
    const { isMultimediaAdinMSANEnabled } = this.props;
    const { imageList } = this.state;
    if (!isMultimediaAdinMSANEnabled) {
      return false;
    }

    return _.filter(imageList, (images) => {
      const landscapeImage = images.find(image => image.Type === ratio);
      return landscapeImage && landscapeImage.IsIncluded;
    }, []).length === 1;
  };

  initializeImagesModelInternal({ perfMarker, ad } = {}) {
    const {
      isMultimediaAdinMSANEnabled,
      ad: adProp,
      odata,
      isMultimediaAd,
      isAdCreatorEnabled,
      isImproveMMA,
    } = this.props;
    const finalAd = ad || adProp;

    this.setUnSupportedRatios(finalAd.Image, true);

    const fetchImagesPromise = isMultimediaAdinMSANEnabled ? getMultiImagesFromMTAssetsAsync(
      odata,
      this.baseURL,
      finalAd.Images,
      isAdCreatorEnabled,
      isImproveMMA,
      this.props.isMMAV2Enabled,
      this.isBoostPortraitImageEnabled,
      this.isBoost200x100ImageEnabled,
      this.isBoostNewAspectRatioSupportEnabled,
      this.isImageFittingEnabled && !this.isMSANBoostEnabled
    ) : getImagesFromMTAssetsAsync(
      odata,
      this.baseURL,
      finalAd.Images,
      isMultimediaAd,
      isAdCreatorEnabled,
      this.isImageFittingEnabled
    );

    if (perfMarker) {
      perfMarker.willInit();
    }

    return fetchImagesPromise.then((images) => {
      let currentSelectedImageId = null;
      let currentSelectedLogoId = null;

      if (this.isMMAEnabled && images.length > 0) {
        currentSelectedLogoId = this.getDefaultCurrentSelectedLogoId(images);
        currentSelectedImageId = this.getDefaultCurrentSelectedImageId(images);
      }

      return {
        images,
        currentSelectedLogoId,
        currentSelectedImageId,
      };
    });
  }

  fetchAndFillImagesAsync() {
    this.setState({ isBlocking: true });

    this.initializeImagesModelInternal({
      perfMarker: this.adPreviewPerfMarker,
    }).then(({
      images,
      currentSelectedLogoId,
      currentSelectedImageId,
    }) => {
      this.setState({
        imageList: images,
        currentSelectedLogoId,
        currentSelectedImageId,
      });
      this.adPreviewPerfMarker.done();

      if (this.props.isMultimediaAdinMSANEnabled) {
        // eslint-disable-next-line newline-per-chained-call
        const imageIds = _.chain(images).flatten().map(img => `${img.id}`).uniq().sortBy().value();
        this.props.activityLogger.signal(`editing ad, image ids:${imageIds.join(',')} image count:${imageIds.length}`, 'responsive ad editor');
      }
    }).finally(() => {
      this.setState({
        isBlocking: false,
      });
    });
  }

  fetchAndFillVideosAsync() {
    this.setState({ isBlocking: true });

    getVideosAndThumbnailsFromMTAssets(
      this.props.odata,
      this.baseURL,
      this.props.ad.Videos
    ).then(({ videoList, thumbnailRecord }) => {
      this.setState({
        videoList,
        thumbnailRecord,
      });
      this.initialVideos = videoList;
    })
      .catch(e => this.setState({
        videoErrorMessages: [this.props.i18n.getString('ImageExperience_Video_Error_LoadVideoFail_Template', e)],
      }))
      .finally(() => {
        this.setState({
          isBlocking: false,
        });
      });
  }

  hasCreatedAd() {
    this.props.activityLogger.signal(`crud-audience-ad-react saveToClient: ${JSON.stringify(this.pilotCheckLogInfo())}`, 'rae-view deprecation');
    return this.state.savedAdsList.length > 0;
  }

  cancelAdAsync() {
    this.props.activityLogger.signal('cancel ad creation', 'responsive ad editor');
    if (this.adEditRef.current) {
      this.adEditRef.current.view.clear();
    }

    this.setState(_.defaults(
      {
        savedAdsList: this.state.savedAdsList,
        isAdEditShown: false,
        isBulkEditMMA: false,
      },
      initialState
    ));
    if (this.props.isBulkEditMMA) {
      this.props.onClose();
    }
  }

  logWithMetadata(api, params = {}) {
    this.props.activityLogger.signal({
      ...this.logInfo,
      ...params,
    }, api);
  }

  saveAdLog(data) {
    const getAssetCount = (assets) => {
      if (assets) {
        try {
          return JSON.parse(assets).length;
        } catch (error) {
          return 0;
        }
      }

      return 0;
    };

    let MMAParams = {};
    if (this.isMMAEnabled) {
      const imageDetails = this.state.imageList.map(images => images.map(image => ({
        isIncluded: image.IsIncluded,
        isManualEdited: image.isManualEdited(),
        type: image.Type,
        source: image.source,
      })));

      MMAParams = {
        imagesCount: this.state.imageList.length,
        imageDetails,
      };
    }

    this.logWithMetadata('responsive ad saved', {
      headlinesCount: getAssetCount(data.Headlines),
      LongHeadlinesCount: getAssetCount(data.LongHeadlines),
      descriptionsCount: getAssetCount(data.Descriptions),
      ...MMAParams,
    });
  }

  saveAdLogForTextRecommendation(saveAdParams) {
    const state = DependencyResolver.get('component/state/index');
    const textSuggestions = state.get('textSuggestions') || {};
    this.logWithMetadata('saveAdLogForTextRecommendation', {
      textSuggestions,
      textSuggestionAdoption: getTextSuggestionAdoption(textSuggestions, saveAdParams),
    });
    state.set('textSuggestions', null);
  }

  shouldUpdateAccountSettingForAllowCrawlImages() {
    return _.chain(this)
      .result('adEditRef')
      .result('current')
      .result('view')
      .result('viewModel')
      .result('showWebsiteImageOptIn', false)
      .value() && this.hasWebsiteImageOptedInObservable();
  }

  /**
   * Called when the save button is pressed. Saves the ad.
   *
   * @returns {undefined} no return value
   *
   */
  saveAdAsync({ recommendSave = false } = {}) {
    this.props.activityLogger.signal(`click save ad: ${this.state.url}`, 'responsive ad editor');
    this.props.activityLogger.signal(`crud-audience-ad-react saveAdAsync: ${JSON.stringify(this.pilotCheckLogInfo())}`, 'rae-view deprecation');
    // If not editing anything, just return
    if (!this.state.isAdEditShown && !recommendSave) {
      return Promise.resolve(true);
    }

    // remove errors
    this.setState({
      imageErrorMessages: [],
      videoErrorMessages: [],
      genericErrorMessages: [],
      errorCodes: [],
    });

    if (this.props.isPlaceholderMMA) {
      this.setState({
        isBlocking: true,
      });
      return this.props.responsiveAdRepository.savePlaceholderMMA(this.props.pageContext)
        .then((data) => {
          if (_.isFinite(data.value)) {
            _.defaults(data, {
              Type: 'Responsive',
            });

            this.props.activityLogger.signal('saved an ad', 'placeholder MMA');
            this.props.activityLogger.signal(`saved an ad: time cost: ${new Date() - this.openTime}, isGrid: ${this.props.isGridDisplay}, isEdit: ${!!this.props.ad}, isVideo: ${this.isVideo}, isMMAinMSAN: ${this.props.isMultimediaAdinMSANEnabled}`, 'responsive ad editor');
            this.openTime = new Date();
            return data;
          }

          return false;
        })
        .catch((response) => {
          if (response) {
            const errorMsgs = [];
            const errors = _.unique(response, false, error => error.Code);

            _.forEach(errors, (error) => {
              const genericErrorMessage = this.props.i18n.getString(`Multimedia_Ad_Error_${error.Code}`)
                || this.props.i18nErrors.getString('ErrorNumber_-1');
              errorMsgs.push(genericErrorMessage);

              this.props.activityLogger.signal(error, 'placeholder MMA creation api error');
            });

            this.setState({
              genericErrorMessages: errorMsgs,
            });
            return false;
          }
          this.logWithMetadata('placeholder MMA saving failed');
          return false;
        })
        .finally(() => {
          this.setState({
            isBlocking: false,
          });
        });
    }

    const initialParams = this.getData();

    if (!this.isDataValid(initialParams)) {
      return Promise.resolve(false);
    }

    this.saveAdLog(initialParams);
    this.saveAdLogForTextRecommendation(initialParams);

    this.setState({
      isBlocking: true,
    });

    return this.getProcessedDataAsync(initialParams)
      .then((result) => {
        const {
          mtModel: params,
          imageToGenerateThumbnail,
        } = result;

        return Promise.all([
          this.props.responsiveAdRepository.saveAdAsync(params),
          this.shouldUpdateAccountSettingForAllowCrawlImages() ? AccountSettingRepository.updateAccountSettings({ AllowCrawlImagesFromLandingPage: 'true' }) : Promise.resolve(),
        ])
          .then(([data]) => {
            if (_.isFinite(Number(data.Id))) {
              // Align with other ad types, since MMA can be mixed with other ads in ad list
              if (this.props.isMultimediaAd) {
                _.defaults(data, {
                  Type: 'Responsive',
                  ThumbnailForAdList: imageToGenerateThumbnail.ThumbnailForAdList,
                  ImageList: this.state.imageList,
                });
                // eslint-disable-next-line no-param-reassign
                data = omitDeletedParameters(data);
              }

              // logging for metrics
              if (this.props.instrumentation) {
                const enableAdCreatorMetrics = this.props.isAdCreatorEnabled
                  || this.props.isFinalUrlImageRetrievalEnabled;
                const { saveAdActivity } =
                  getAdCreatorInstrumentation(this.props.instrumentation, this.adCreatorScenario);
                const imageList = getFlattenedImageAssetList(this.state.imageList, this.props.isMultimediaAdinMSANEnabled, this.props.isMultimediaAd);

                logSaveAdInfoForMetrics({
                  data,
                  saveAdActivity,
                  imageList,
                  state: this.state,
                  enableAdCreatorMetrics,
                });
              }

              // log for the Ad recommendation
              if (this.state.isRecommendAd) {
                const recommendData = getRecommendCacheByUrl(this.state.url);
                const adData = _.extend(_.pick(data, ['Id', 'FinalUrls', 'AdGroup']), {
                  Images: JSON.parse(data.Images),
                  LongHeadlines: JSON.parse(data.LongHeadlines),
                  Descriptions: JSON.parse(data.Descriptions),
                  Headlines: JSON.parse(data.Headlines),
                });
                this.props.activityLogger.signal(
                  `save the ad from recommendation. The ad id is: ${data.Id}. The final URL: ${this.state.url}. The ad data is: ${JSON.stringify(adData)}. The origin recommend data: ${JSON.stringify(recommendData)}. The assetid and url mapping: ${JSON.stringify(this.recommendAssetIdImageUrlMap)} `,
                  'responsive ad recommendation'
                );
              }

              // Only for a creation wizard scenario
              if (!this.props.isGridDisplay) {
                this.onAdSaved(data, imageToGenerateThumbnail);
              }

              this.props.activityLogger.signal('saved an ad', 'responsive ad editor');
              this.props.activityLogger.signal(`saved an ad: time cost: ${new Date() - this.openTime}, isGrid: ${this.props.isGridDisplay}, isEdit: ${!!this.props.ad}, isVideo: ${this.isVideo}, isMMAinMSAN: ${this.props.isMultimediaAdinMSANEnabled}`, 'responsive ad editor');
              this.openTime = new Date();
              return data;
            }

            return false;
          });
      })
      .catch((response) => {
        if (response) {
          const errors = _.unique(response.errors, false, error => error.ErrorNumber);

          this.setResponseErrors(errors);
          if (this.isVideo) {
            const newErrors = errors.map(error => (
              <React.Fragment>
                {this.i18nErrors.getString(bulkApiErrorNumberToErrorMessageMapping[`API_ErrorNumber_${error.ErrorNumber}`])}
                <HelpPopup
                  topic="pop_BA_VideoAds_VideoRequirements"
                  aria-label={this.props.i18n.getString('Click to learn more about {{item}}', { item: this.props.i18n.getString('ImageExperience_Video_Requirement') })}
                />
              </React.Fragment>
            ));

            this.setState({
              videoErrorMessages: [
                ...this.state.videoErrorMessages,
                ...newErrors,
              ],
            });
          }
          _.each(errors, (error) => {
            this.props.activityLogger.signal(error.Error, 'responsive ad creation api error');
          });
          return false;
        }
        this.logWithMetadata('responsive ad saving failed');
        return false;
      })
      .finally(() => {
        this.setState({
          isBlocking: false,
        });
      });
  }

  /**
   * Called when the save button is pressed. Saves the ad to client in ad group creation
   * for multimedia ad now.
   *
   * @returns {Promise} Promise to return the ad
   *
   */
  saveToClient() {
    this.props.activityLogger.signal('click save ad to client', 'responsive ad editor');
    this.props.activityLogger.signal(`crud-audience-ad-react saveToClient: ${JSON.stringify(this.pilotCheckLogInfo())}`, 'rae-view deprecation');
    // If not editing anything, just return
    if (!this.state.isAdEditShown) {
      return Promise.resolve(true);
    }

    // remove errors
    this.setState({
      imageErrorMessages: [],
      videoErrorMessages: [],
      genericErrorMessages: [],
      errorCodes: [],
    });

    const initialParams = this.getData(this.isUpdate);

    if (!this.isDataValid(initialParams)) {
      return Promise.resolve(false);
    }

    return Promise.all([
      this.getProcessedDataAsync(initialParams),
      this.shouldUpdateAccountSettingForAllowCrawlImages() ? AccountSettingRepository.updateAccountSettings({ AllowCrawlImagesFromLandingPage: 'true' }) : Promise.resolve(),
    ])
      .then(([result]) => {
        let params = result.mtModel;

        if (this.props.isMultimediaAd) {
          const { imageToGenerateThumbnail } = result;

          _.defaults(params, {
            Type: 'Responsive',
            ThumbnailForAdList: imageToGenerateThumbnail.ThumbnailForAdList,
            ImageList: this.state.imageList,
          });

          params = omitDeletedParameters(params); // eslint-disable-line no-param-reassign
        }

        return params;
      });
  }

  progressCb() {
    this.adEditRef.current.view.showProgress(true);
  }
  saveMMABulkConversion() {
    const self = this;
    this.setState({
      imageErrorMessages: [],
      videoErrorMessages: [],
      genericErrorMessages: [],
      errorCodes: [],
    });
    const initialParams = this.getData();

    if (!this.isDataValid(initialParams)) {
      return Promise.resolve(false);
    }

    this.setState({
      isBlocking: true,
    });
    return this.getProcessedDataAsync(initialParams)
      .then((result) => {
        const {
          mtModel: params,
        } = result;

        const bulkParams = this.getBulkEditParams(params);
        return bulkEditChange({
          params: bulkParams,
          progressCB: _.bind(self.progressCb, self),
          completeCB: (response) => {
            this.adEditRef.current.view.showProgress(false);
            self.setState({
              isBlocking: false,
            });
            if (response.Status === 'CompletedWithErrors') {
              self.adEditRef.current.view.showErrors(true);
              this.adEditRef.current.view.successCount(response.SuccessRowCount);
              this.adEditRef.current.view.totalCount(response.TotalRowCount);
              self.adEditRef.current.view.errorCount(response.ErrorRowCount);
              self.adEditRef.current.view.inlineErrors(response);
              self.setState({
                isBulkEditMMAUnSaved: true,
                bulkEditMMAFailed: true,
              });
            } else if (response.Status === 'Completed') {
              self.logWithMetadata('mma bulk create successfully');
              self.props.onAdSaved();
            }
            return response;
          },
          failedCB: (e) => {
            this.logWithMetadata(`mma bulk conversion failed. ${JSON.stringify(e)}`);
            self.setState({
              isBulkEditMMAUnSaved: true,
              bulkEditMMAFailed: true,
            });
            const errorMes = e.errors.map(error => JSON.stringify(error));
            this.setState({
              genericErrorMessages: [
                ...this.state.genericErrorMessages,
                ...errorMes,
              ],
            });
          },
        })
          .finally(() => {
            this.setState({
              isBlocking: false,
            });
          });
      })
      .catch((response) => {
        const errors = _.unique(response.errors, false, error => error.ErrorNumber);
        this.setResponseErrors(errors);
        this.logWithMetadata('mma bulk get params failed');
        return false;
      })
      .finally(() => {
        this.setState({
          isBlocking: false,
        });
      });
  }

  isMeetingMinimumRequirement(MMAImageList) {
    const aspectRatios =
      constants.getMmaAspectRatios();
    const ratioCounts = _.mapObject(aspectRatios, () => 0);
    _.each(MMAImageList, imageArray =>
      _.each(imageArray, (imageObj) => {
        if (imageObj.isIncluded) {
          ratioCounts[imageObj.type] += 1;
        }
      }));
    return _.every(ratioCounts, (count, type) => count >= aspectRatios[type].minimumRequirements);
  }

  /**
   * Makes sure that all the needed parameters are contained on the object, and valid, before this
   * is used to save the ad.
   *
   * @param {object} params The object to be sent on the save request.
   *
   * @returns {boolean} True if everything is ok, false if values are missing or invalid.
   *
   */
  isDataValid(params) {
    if (this.isVideo) {
      if (this.state.videoUploading) {
        this.setState({
          videoErrorMessages: [this.props.i18n.getString('ImageExperience_VideosUploading')],
        });
        return false;
      }
      if (this.state.videoList.length !== constants.videoTypesWithOrder.length) {
        this.setState({
          videoErrorMessages: [this.props.i18n.getString('ImageExperience_VideosMissing')],
        });
        return false;
      }
      // Only videos w/ Id and Status in [Draft, Active, Unverified] are valid.
      const invalidVideos = this.state.videoList.filter(videoObj =>
        videoObj.Id === 0 ||
        (videoObj.Status !== 'Draft' &&
          videoObj.Status !== 'Active' &&
          videoObj.Status !== 'Unverified'));
      if (invalidVideos.length > 0) {
        this.setState({
          videoErrorMessages: [this.props.i18n.getString('ImageExperience_InvalidVideo')],
        });
        return false;
      }
      return this.adEditRef.current.view.isDataValid(params);
    } else if (this.props.isMultimediaAd) {
      const MMAImageList = this.getImageListWithoutLogo(this.state.imageList);
      let imageErrorMessages = [];
      if (MMAImageList.length <= 0 ||
        !_.every(
          MMAImageList,
          imageArray => _.every(imageArray, imageObj => !_.isNull(imageObj.Id))
        ) ||
        !_.some(
          MMAImageList,
          imageArray => _.some(imageArray, imageObj => imageObj.isIncluded === true)
        )) {
        // should include at least one ratio
        imageErrorMessages = [this.props.i18n.getString('ImageExperience_ImagesAspectRatioRequired')];
      }

      if (this.isMultiMediaAdsPhase2Enabled && !this.isMeetingMinimumRequirement(MMAImageList)) {
        // should include minimum ratios in phase2
        imageErrorMessages = [this.props.i18n.getString('ImageExperience_MinimumAspectRatioRequired')];
      }

      if (_.isEmpty(imageErrorMessages)) {
        return this.adEditRef.current.view.isDataValid(params);
      }

      this.setState({ imageErrorMessages });
      if (this.props.isBulkEditMMA) {
        return this.adEditRef.current.view.isDataValid(params);
      }
      return false;
    } else if (this.props.isMultimediaAdinMSANEnabled) {
      const MMAImageList = this.getImageListWithoutLogo(this.state.imageList);

      let imageErrorMessages = [];
      if (MMAImageList.length === 0) {
        imageErrorMessages = [this.props.i18n.getString('ImageExperience_ImagesRequired')];
        this.setState({ imageErrorMessages });
        return false;
      }

      const isMMAV2Format = this.props.isMMAV2Enabled && _.some(MMAImageList, images => images.find(image => image.Type === 'OriginalImage'));

      const noLandscapeImageIncluded = MMAImageList
        .map(images => images.find(image => image.Type === 'Image191x100'))
        .every(image => !image.IsIncluded);

      const noOriginalImageIncluded = this.props.isMMAV2Enabled && MMAImageList
        .map(images => images.find(image => image.Type === 'OriginalImage'))
        .every(image => !image.IsIncluded); // this is always true since original image is not showing on UI

      if (isMMAV2Format && noOriginalImageIncluded) {
        imageErrorMessages = [this.props.i18n.getString('ImageExperience_OriginalImageRequired')];
        this.setState({ imageErrorMessages });
        return false;
      }

      if (!isMMAV2Format && noLandscapeImageIncluded) {
        imageErrorMessages = [this.props.i18n.getString('ImageExperience_LandscapeImageRequired')];
        this.setState({ imageErrorMessages });
        return false;
      }
      return this.adEditRef.current.view.isDataValid(params);
    } else if (this.state.imageList.length === this.imageTypesWithOrder.length &&
      _.every(this.state.imageList, imageObj => imageObj.Id > 0)) {
      return this.adEditRef.current.view.isDataValid(params);
    }
    this.setState({
      imageErrorMessages: [this.props.i18n.getString('ImageExperience_ImagesRequired')],
    });

    return false;
  }

  renderImageExperience(previewTexts, adPreviewConfig) {
    // Adding this to make sure ImageExperience is mounted on every newly created ad
    const shouldRender = this.isVideo ? !this.state.isBlocking : true;
    return (shouldRender &&
      <React.Fragment>
        <ImageExperience
          isBulkEditMMA={this.props.isBulkEditMMA}
          shortHeadline={previewTexts.shortHeadline}
          longHeadline={previewTexts.longHeadline}
          description={previewTexts.description}
          businessName={previewTexts.businessName}
          url={previewTexts.url}
          callToAction={previewTexts.callToAction}
          odata={this.props.odata}
          cid={this.props.cid}
          aid={this.props.aid}
          i18n={this.props.i18n}
          newI18n={this.props.newI18n}
          dateFormat={_.get(this.props.pageContext, ['CurrentUser', 'CultureDateTimeFormat', 'ShortDatePattern'])}
          timeZone={_.get(this.props.pageContext, ['CurrentAccount', 'TimeZone'])}
          imageList={this.state.imageList}
          isMultimediaAdinMSANEnabled={this.props.isMultimediaAdinMSANEnabled}
          videoList={this.state.videoList}
          customThumbnailRecord={this.state.thumbnailRecord}
          currentSelectedImageId={this.state.currentSelectedImageId}
          currentSelectedLogoId={this.state.currentSelectedLogoId}
          onImageEditCancelled={this.onImageEditCancelled}
          onImageSelected={this.onImageSelected}
          onImageListUpdated={
            (imageList, currentSelectedImageId, isLogo) =>
              this.onImageListUpdated(imageList, currentSelectedImageId, isLogo)
          }
          onImagePreviewRequested={this.onImagePreviewRequested}
          onVideoListUpdated={this.onVideoListUpdated}
          onVideoPreviewRequested={this.onVideoPreviewRequested}
          onSaveThumbnailAsDraft={this.onSaveThumbnailAsDraft}
          onUpdateFinalUrlPrefix={this.onUpdateFinalUrlPrefix}
          onUpdateFinalUrl={this.onUpdateFinalUrl}
          perfMarker={this.props.perfMarker}
          isForVNext={this.props.isForVNext}
          isAudienceAd={this.props.isAudienceCampaign}
          isMultimediaAd={this.props.isMultimediaAd}
          isStockPhotoEnabled={this.props.isStockPhotoEnabled}
          oDataConfig={this.props.oDataConfig}
          genericImage={this.props.genericImage}
          activityLogger={this.props.activityLogger}
          permissions={this.props.permissions}
          isVideo={this.props.permissions.IsVideoAdsForCampaignEnabled && this.isVideo}
          onVideoUploadStatusUpdate={this.onVideoUploadStatusUpdate}
          cropImage={this.state.cropImage}
          suggestion={this.state.suggestion}
          suggestionPoller={this.suggestionPoller}
          isAdCreatorEnabled={this.props.isAdCreatorEnabled}
          isFinalUrlImageRetrievalEnabled={this.props.isFinalUrlImageRetrievalEnabled}
          isLogoEnabled={this.isLogoEnabled}
          imageErrorMessages={this.state.imageErrorMessages}
          mediaRepository={this.mediaRepository}
          finalUrl={this.state.url}
          finalUrlProtocol={this.state.protocol}
          setAddNewImageCallback={(callback) => {
            this.setState({ addImageCallback: callback });
          }}
          setOpenAddImageCallback={(callback) => {
            this.setState({ openAddImageCallback: callback });
          }}
          adCreatorScenario={this.adCreatorScenario}
          onManualCropLogo={() => this.setState({ hasManualCroppedLogo: true })}
          onManualCropImage={() => this.setState({ hasManualCroppedImage: true })}
          preferencesService={this.props.preferencesService}
          isImproveMMA={this.props.isImproveMMA}
          isMMAV2Enabled={this.props.isMMAV2Enabled}
          isMSANBoostEnabled={this.isMSANBoostEnabled}
          isBoost200x100ImageEnabled={this.isBoost200x100ImageEnabled}
          isBoostNewAspectRatioSupportEnabled={this.isBoostNewAspectRatioSupportEnabled}
          enableUnifiedAdPreview={this.enableAdPreviewLibrary}
          adPreviewConfig={adPreviewConfig}
          isAudienceMMAWithLogoAndCTA={this.isMSANLogoAndCTAForMMAEnabled}
          showCopilotOptionForImage={this.props.permissions.IsBackgroundSceneEnabled}
          assetLibraryEventHandler={{
            onUploadImage: (imgId) => {
              if (this.props.isMultimediaAdinMSANEnabled) {
                this.props.activityLogger.signal(`uploaded image audience ad editor, isEditing:${!!this.props.ad}, image id:${imgId}`, 'responsive ad editor');
              }
            },
          }}
          supportImageUpscale={this.isAudienceImageUpscale}
          isImageFittingEnabled={this.isImageFittingEnabled}
        />
        {
          !this.isLogoEnabled && this.state.imageErrorMessages.length > 0 &&
          <div className="image-required-error error" role="alert">
            {
              this.state.imageErrorMessages.map((errMsg, index) => (
                <div className="error" key={`${index}`}>
                  {errMsg}
                </div>
              ))
            }
          </div>
        }
        {
          this.state.videoErrorMessages.length > 0 &&
          <div className="image-required-error error" role="alert">
            {
              this.state.videoErrorMessages.map((errMsg, index) => (
                <div className="error" key={`${index}`}>
                  {errMsg}
                </div>
              ))
            }
          </div>
        }
        {
          this.state.draftUnsaved &&
          <MessageBar
            messageBarType={MessageBarType.warning}
            isMultiline={false}
            styles={{ root: { width: '100%' } }}
            onDismiss={() => this.setState({ draftUnsaved: false })}
          >
            {this.props.i18n.getString('ImageExperience_UnsavedDraft_Warn')}
          </MessageBar>
        }
      </React.Fragment>
    );
  }

  renderAdEdit() {
    return (
      <BackboneViewWrapper
        View={AdEdit}
        ref={this.adEditRef}
        options={{
          viewContext: this.props.viewContext,
          pageContext: this.props.pageContext,
          isVideo: this.isVideo,
          scenario: this.props.scenario,
          ad: this.state.currentAd,
          biddingScheme: this.props.biddingScheme,
          campaignSettings: this.state.campaignSettings,
          setUpAdWithRecommendAd: this.setUpAdWithRecommendAd,
          shouldOverrideAdInEditor: this.shouldOverrideAdInEditor,
          baseURL: this.baseURL,
          newI18n: this.props.i18n,
          hotspots: this.state.hotspots,
          onUpdateHotspots: this.onUpdateHotspots,
          adId: this.state.currentAd && this.state.currentAd.Id,
          isSimplifyAudienceCreation: this.isSimplifyAudienceCreation,
          isForVNext: this.props.isForVNext,
          isMobileUrlEnabled: this.props.isMobileUrlEnabled,
          isImpressionTrackingUrlsEnabled: this.props.isImpressionTrackingUrlsEnabled, // eslint-disable-line max-len
          isAdRecommendationMSANEnabled: this.isAdRecommendationMSANEnabled,
          isAudienceCampaign: this.props.isAudienceCampaign,
          isMultimediaAd: this.props.isMultimediaAd,
          isBulkEditMMA: this.props.isBulkEditMMA,
          activityLogger: this.props.activityLogger,
          isMSANLogoAndCTAForMMAEnabled: this.isMSANLogoAndCTAForMMAEnabled,
          websiteImageOptInPreferenceName:
            this.getOptInPreferenceFlag(),
          hasWebsiteImageOptedInObservable:
            this.hasWebsiteImageOptedInObservable,
          instrumentation: this.props.instrumentation,
          parsedTextMaxLengthExtension: this.props.parsedTextMaxLengthExtension,
          edm: edmCampaign,
          jsdata: this.props.jsdata,
          onClose: this.cancelAdAsync,
          isImproveMMA: this.props.isImproveMMA,
          isMMAV2Enabled: this.props.isMMAV2Enabled,
          isRecommendation: this.props.isRecommendation,
        }}
        eventsToActions={[
          {
            event: 'fieldUpdated',
            action: this.onAdFieldUpdated,
          },
        ]}
      />
    );
  }

  render() {
    this.perfMarker.willRender();

    const previewTexts = this.getPreviewTexts();

    const {
      isMultimediaAdinMSANEnabled, isMultimediaAd, isPlaceholderMMA,
    } = this.props;

    const { savedAdsList, errorCodes } = this.state;

    if (this.state.blockCarousel &&
      (!!this.state.suggestion.inProgress || this.state.carousel.isError)) {
      this.setState({
        blockCarousel: false,
      });
    }

    const adPreviewConfig = getUnifiedAdPreviewConfig({
      isMultimediaAdinMSANEnabled,
      isMultimediaAd,
      isMSANBoostEnabled: this.isMSANBoostEnabled,
      isMMAV2Enabled: this.props.isMMAV2Enabled,
      isBoost200x100ImageEnabled: this.isBoost200x100ImageEnabled,
      isBoostNewAspectRatioSupportEnabled: this.isBoostNewAspectRatioSupportEnabled,
    });
    const PreviewCarouselComponent = this.enableAdPreviewLibrary ? UnifiedPreviewCarousel : PreviewCarousel;
    const MMAMSANPreviewCarouselComponent = this.enableAdPreviewLibrary ? UnifiedMMAMSANPreviewCarousel : MMAPreviewCarousel;
    const imagePreview = isMultimediaAdinMSANEnabled ?
      (<MMAMSANPreviewCarouselComponent
        imageList={this.getImagesForPreview()}
        totalImageListCount={this.getImageListWithoutLogo(this.state.imageList).length}
        previewTexts={previewTexts}
        isOnlyOneIncludedImage={this.isOnlyOneIncludedImage}
        i18n={this.props.i18n}
        activityLogger={this.props.activityLogger}
        enableAutoRotate={this.state.enableAutoRotate}
        genericImage={this.props.genericImage}
        onCropImage={this.onCropImage}
        hotspots={this.state.hotspots}
        onAddAspectRatio={this.onAddAspectRatio}
        onRemoveAspectRatio={this.onRemoveAspectRatio}
        isMSANBoostEnabled={this.isMSANBoostEnabled}
        logo={_.find(this.getLogo(this.state.imageList), logo => logo.isIncluded)}
        isAdCreatorEnabled={this.props.isAdCreatorEnabled}
        adCreatorScenario={this.adCreatorScenario}
        instrumentation={this.props.instrumentation}
        onUsedViewAllPlacements={() => this.setState({ hasUsedViewAllPlacements: true })}
        isImproveMMA={this.props.isImproveMMA}
        newI18n={this.props.newI18n}
        permissions={this.props.permissions}
        isMMAV2Enabled={this.props.isMMAV2Enabled}
        isBoost200x100ImageEnabled={this.isBoost200x100ImageEnabled}
        isBoostNewAspectRatioSupportEnabled={this.isBoostNewAspectRatioSupportEnabled}
        adPreviewConfig={adPreviewConfig}
        isImageFittingEnabled={this.isImageFittingEnabled}
      />)
      :
      (<PreviewCarouselComponent
        ref={this.imagePreviewCarouselRef}
        imageList={this.getImagesForPreview()}
        previewTexts={previewTexts}
        enableAutoRotate={this.state.enableAutoRotate}
        i18n={this.props.i18n}
        permissions={this.props.permissions}
        genericImage={this.props.genericImage}
        isMultimediaAd={isMultimediaAd}
        onCropImage={this.onCropImage}
        onAddAspectRatio={this.onAddAspectRatio}
        onRemoveAspectRatio={this.onRemoveAspectRatio}
        isAdCreatorEnabled={this.props.isAdCreatorEnabled}
        instrumentation={this.props.instrumentation}
        totalImageListCount={this.state.imageList.length}
        adCreatorScenario={this.adCreatorScenario}
        onUsedViewAllPlacements={() => this.setState({ hasUsedViewAllPlacements: true })}
        isImproveMMA={this.props.isImproveMMA}
        newI18n={this.props.newI18n}
        adPreviewConfig={adPreviewConfig}
      />);

    return (
      <div className={classnames('crud-audience-ad-react', this.isMMAEnabled ? 'crud-multimedia-ad-react' : '')}>
        <UiBlocker
          blocking={this.state.isBlocking}
          loadingText={this.props.i18n.getString('Loading')}
        >{this.props.renderMMABulkConversionHeader && this.props.renderMMABulkConversionHeader({ selectedRowCount: this.props.selectedRowCount })}
          {
            !this.props.isGridDisplay && !this.props.isBulkEditMMA &&
            // don't show ad list in new audience creation flow
            !this.isSimplifyAudienceCreation &&
            <SavedAdList
              i18n={this.props.i18n}
              savedAdsList={this.state.savedAdsList}
              isEditable={!this.state.isAdEditShown}
              responsiveAdRepository={this.props.responsiveAdRepository}
              onEditAd={this.onEditAd}
              onRemoveAd={this.onRemoveAd}
              onCreateAnotherAd={this.onCreateAd}
              activityLogger={this.props.activityLogger}
              isVideo={this.isVideo}
            />
          }
          {
            !this.props.isGridDisplay &&
            !this.state.isAdEditShown &&
            this.isAdRecommendationMSANEnabled &&
            this.props.isAudienceCampaign &&
            !this.props.isBulkEditMMA &&
            // don't show recommend ad list in new audience creation flow
            !this.isSimplifyAudienceCreation &&
            !this.isVideo &&
            <div>
              <RecommendAdList
                url={_.get(savedAdsList, ['0', 'FinalUrls', '0'])}
                baseURL={this.baseURL}
                errorCodes={errorCodes}
                i18n={this.props.i18n}
                i18nErrors={this.props.i18nErrors}
                setUpAdWithRecommendAd={this.setUpAdWithRecommendAd}
                activityLogger={this.props.activityLogger}
              />
              {/* init ad editor in order to save the ad when isAdEditShown is false */}
              <div style={{ display: 'none' }} >{this.renderAdEdit()}</div>
            </div>
          }
          {
            this.state.isAdEditShown &&
            <div className="ad-content-container">
              {
                !isPlaceholderMMA &&
                <React.Fragment>
                  <div className="ad-iamge-container">
                    {!isMultimediaAd && !this.props.isAdCreatorEnabled &&
                      this.renderImageExperience(previewTexts, adPreviewConfig)}
                  </div>
                  <Row className="ad-edit-and-preview-container">
                    <Col sm={5}>
                      {(this.props.isMultimediaAd || this.props.isAdCreatorEnabled) &&
                        this.isLogoEnabled &&
                        this.renderImageExperience(previewTexts, adPreviewConfig)}
                      {this.isBoostPortraitImageEnabled && (
                        <BoostImage
                          cid={this.props.cid}
                          aid={this.props.aid}
                          i18n={this.props.i18n}
                          campaignId={this.props.cid} // [todo]
                          permissions={this.props.permissions}
                          oDataConfig={this.props.oDataConfig}
                          instrumentation={this.props.instrumentation}
                          activityLogger={this.props.activityLogger}
                          url={previewTexts.url}
                          preferencesService={this.props.preferencesService}
                          perfMarker={this.props.perfMarker}
                          onSavePortraitImage={portraitImage => this.onSavePortraitImage(portraitImage)}
                          associatedImages={this.props.ad && this.props.ad.Images}
                          dateFormat={_.get(this.props.pageContext, ['CurrentUser', 'CultureDateTimeFormat', 'ShortDatePattern'])}
                          timeZone={_.get(this.props.pageContext, ['CurrentAccount', 'TimeZone'])}
                          serverContext={this.props.serverContext}
                        />
                      )}
                      <div className="ad-edit-with-image-container">
                        {this.renderAdEdit()}
                      </div>
                    </Col>
                    <Col sm={7}>
                      <div>
                        {(this.props.isMultimediaAd || this.props.isAdCreatorEnabled) &&
                          !this.isLogoEnabled &&
                          this.renderImageExperience(previewTexts, adPreviewConfig)}
                        {this.isVideo ?
                          <VideoPreviewCarousel
                            ref={this.videoPreviewCarouselRef}
                            videoList={this.state.videoList}
                            customThumbnailRecord={this.state.thumbnailRecord}
                            previewTexts={previewTexts}
                            i18n={this.props.i18n}
                            activityLogger={this.props.activityLogger}
                          /> : imagePreview
                        }
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              }
              {
                !isMultimediaAd &&
                <div className="audience-ads-policy-container">
                  <div className="alert alert-info">
                    <div className="alert-image" />
                    <div className="alert-info-inline">
                      <span>
                        {`${this.props.i18n.getString('Audience_Campaign_Ad_Policy_Description')} `}
                      </span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://go.microsoft.com/fwlink/?linkid=2028852"
                      >
                        {this.props.i18n.getString('Audience_Campaign_Ad_Policy_Label')}
                      </a>
                      <span>.</span>
                    </div>
                  </div>
                </div>
              }
              <div className="generic-errors error">
                {
                  this.state.genericErrorMessages.map((errMsg, index) => (
                    <div className="error" key={`${index}`}>
                      {errMsg}
                    </div>
                  ))
                }
              </div>
              {
                !this.props.isGridDisplay && !this.props.isBulkEditMMA &&
                <div className="ad-edit-action-buttons">
                  <Button
                    btnStyle="primary"
                    className="save-ad-button"
                    onClick={this.saveAdAsync}
                    disabled={!this.state.hasWebsiteImageOptedIn}
                  >
                    {this.props.i18n.getString('Audience_Campaign_Ad_Save')}
                  </Button>
                  {
                    this.state.savedAdsList.length > 0 &&
                    <Button
                      btnStyle="default"
                      className="cancel-ad-button"
                      onClick={this.cancelAdAsync}
                    >
                      {this.props.i18n.getString('Audience_Campaign_Cancel_Label')}
                    </Button>
                  }
                </div>
              }
              {
                this.props.isBulkEditMMA && this.props.renderMMABulkConversionActionButtons && !this.state.isBlocking &&
                this.props.renderMMABulkConversionActionButtons({
                  saveMMABulkConversion: this.saveMMABulkConversion,
                  cancelMMABulkConversion: this.cancelAdAsync,
                  isUnSaved: this.state.isBulkEditMMAUnSaved || this.state.isBlocking,
                })
              }
              {
                this.props.isBulkEditMMA && this.state.bulkEditMMAFailed &&
                <MessageBar
                  messageBarType={MessageBarType.warning}
                  isMultiline={false}
                  styles={{ root: { width: '100%' } }}
                  onDismiss={() => this.setState({ bulkEditMMAFailed: false })}
                >
                  {this.props.newI18n.getString(_TL_('we’re unable to save your multimedia ad(s) due to an error. Please try again. '))}
                </MessageBar>
              }
            </div>
          }
        </UiBlocker>
      </div>
    );
  }
}

CrudAudienceAdReact.propTypes = {
  cid: PropTypes.string.isRequired,
  aid: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  i18nErrors: PropTypes.shape({
    getBulkApiErrors: PropTypes.func.isRequired,
    getString: PropTypes.func.isRequired,
  }).isRequired,
  responsiveAdRepository: PropTypes.shape({
    getAdAsync: PropTypes.func.isRequired,
    removeAdAsync: PropTypes.func.isRequired,
    saveAdAsync: PropTypes.func.isRequired,
    savePlaceholderMMA: PropTypes.func.isRequired,
    saveMMABulkConversion: PropTypes.func,
  }).isRequired,
  odata: PropTypes.shape({
    get: PropTypes.func.isRequired,
    post: PropTypes.func.isRequired,
  }).isRequired,
  genericImage: PropTypes.string.isRequired,
  viewContext: PropTypes.shape({
    currentAdGroup: PropTypes.shape({
      Id: PropTypes.number,
    }),
    currentCampaign: PropTypes.shape({
      Id: PropTypes.number,
    }),
  }).isRequired,
  pageContext: PropTypes.objectOf(PropTypes.any),
  isMobileUrlEnabled: PropTypes.bool,
  isImpressionTrackingUrlsEnabled: PropTypes.bool,
  isGridDisplay: PropTypes.bool,
  onAdSaved: PropTypes.func,
  onClose: PropTypes.func,
  ad: PropTypes.objectOf(PropTypes.any),
  isMultimediaAdinMSANEnabled: PropTypes.bool,
  isAdRecommendationMSANEnabled: PropTypes.bool,
  perfMarker: PropTypes.shape({
    willFetchFile: PropTypes.func.isRequired,
    willInit: PropTypes.func.isRequired,
    willFetchData: PropTypes.func.isRequired,
    willRender: PropTypes.func.isRequired,
    done: PropTypes.func.isRequired,
    createChild: PropTypes.func.isRequired,
  }),
  isForVNext: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  isPlaceholderMMA: PropTypes.bool,
  isAudienceCampaign: PropTypes.bool,
  isStockPhotoEnabled: PropTypes.bool,
  isBulkEditMMA: PropTypes.bool,
  oDataConfig: PropTypes.shape({
    odataRootUrl: PropTypes.string,
    odataPath: PropTypes.string,
    odataToken: PropTypes.string,
  }),
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }).isRequired,
  permissions: PropTypes.shape({
    IsBoostPortraitImageEnabled: PropTypes.bool,
    IsStockPhotoFilterEnabled: PropTypes.bool,
    IsVideoAdsForCampaignEnabled: PropTypes.bool,
    IsMultiMediaAdsPhase2Enabled: PropTypes.bool,
    IsVideoAdEditorEnabled: PropTypes.bool,
    IsAmplifyEnabled: PropTypes.bool,
    IsBoost200x100ImageEnabled: PropTypes.bool,
    IsBoostNewAspectRatioSupportEnabled: PropTypes.bool,
    IsMSANLogoAndCTAForMMAEnabled: PropTypes.bool,
    dynamic: PropTypes.object,
    IsBackgroundSceneEnabled: PropTypes.bool,
  }),
  isVideo: PropTypes.bool,
  isAdCreatorEnabled: PropTypes.bool,
  isFinalUrlImageRetrievalEnabled: PropTypes.bool,
  isRecommendation: PropTypes.bool,
  scenario: PropTypes.string,
  jsdata: PropTypes.shape({}),
  instrumentation: PropTypes.shape({
    addScenario: PropTypes.func,
  }).isRequired,
  enableOfflinePollingDelay: PropTypes.bool,
  hasWebsiteImageOptedInObservable: PropTypes.func,
  newI18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  preferencesService: PropTypes.shape({
    setAtUserLevel: PropTypes.func,
    findByNameAtUserLevel: PropTypes.func,
  }),
  parsedTextMaxLengthExtension: PropTypes.shape({
    extend: PropTypes.func,
  }),
  selectedItems: PropTypes.arrayOf(PropTypes.shape({})),
  allPages: PropTypes.bool,
  filterService: PropTypes.shape({}),
  selectedRowCount: PropTypes.number,
  renderMMABulkConversionHeader: PropTypes.func,
  renderMMABulkConversionActionButtons: PropTypes.func,
  isImproveMMA: PropTypes.bool,
  isMMAV2Enabled: PropTypes.bool,
  biddingScheme: PropTypes.shape({}),
  serverContext: PropTypes.shape({}),
};

CrudAudienceAdReact.defaultProps = {
  onAdSaved: _.noop,
  onClose: _.noop,
  ad: null,
  pageContext: {},
  perfMarker: {
    willFetchFile: _.noop,
    willInit: _.noop,
    willFetchData: _.noop,
    willRender: _.noop,
    done: _.noop,
    createChild: _.noop,
  },
  isForVNext: false,
  isAudienceCampaign: false,
  scenario: '',
  isMultimediaAd: false,
  isPlaceholderMMA: false,
  isStockPhotoEnabled: false,
  isMultimediaAdinMSANEnabled: false,
  isMobileUrlEnabled: true,
  isImpressionTrackingUrlsEnabled: false,
  isGridDisplay: false,
  isBulkEditMMA: false,
  oDataConfig: null,
  permissions: { dynamic: {} },
  isVideo: false,
  isAdRecommendationMSANEnabled: false,
  isAdCreatorEnabled: false,
  isFinalUrlImageRetrievalEnabled: false,
  isRecommendation: false,
  jsdata: {},
  enableOfflinePollingDelay: true,
  hasWebsiteImageOptedInObservable: null,
  preferencesService: {},
  parsedTextMaxLengthExtension: {
    extend: _.noop,
  },
  selectedItems: [],
  allPages: false,
  selectedRowCount: 0,
  renderMMABulkConversionActionButtons: _.noop,
  renderMMABulkConversionHeader: _.noop,
  filterService: {},
  isImproveMMA: false,
  isMMAV2Enabled: false,
  biddingScheme: {},
  serverContext: {},
};
